import { useState } from 'react';
import { Nullable } from 'chaika-common-types';
import { OptionType } from '@components/Select';

export function useLegalEntityHandlers() {
    const [selectedLegalEntity, setSelectedLegalEntityOption] = useState<Nullable<OptionType<string>>>(null);

    function onSelectLegalEntity(item: OptionType<string>): void {
        setSelectedLegalEntityOption(item);
    }

    return {
        selectedLegalEntity,
        onSelectLegalEntity,
    };
}
